import http from '../../../utils/fetch';
export default {
    baseurl: '/api/swyl/v1/demo/industryTargetImport',

    query(query) {
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            params: query
        });
    },





}
